import React, { useState, useEffect } from "react"
import BoundInOut from "./tabs/boundInOut"
import Setting from "./tabs/setting"
import Flatpickr from "react-flatpickr"
import "flatpickr/dist/themes/airbnb.css"
import toast from "react-hot-toast"
import { formatFaxNumber } from "./../utils/common"
import { ArrowBigLeft } from "lucide-react"

const FaxList = ({
  selectedFax,
  setSelectedFax,
  selectedPractice,
  tab,
  setTab,
  tabs,
  flgReloadFaxes,
  authUser,
  reloadPractices,
  practicesLength,
  practices,
  setSelectedPractice,
  appLoading,
  faxListWidth,
  faxViewWidth = 0,
}) => {
  const [searchText, setSearchText] = useState("")
  const [selectedDateRange, setSelectedDateRange] = useState(null)
  const [dateRange, setDateRange] = useState([])

  // datepicker
  const today = new Date()
  const yesterday = new Date()
  yesterday.setDate(today.getDate() - 1)
  const twoDaysAgo = new Date()
  twoDaysAgo.setDate(today.getDate() - 2)
  const past180Days = new Date()
  past180Days.setDate(today.getDate() - 180)

  const handleTabClick = (key) => {
    setTab(key) // Update selected tab on click
    setSearchText("")
    setSelectedDateRange(null)
    setDateRange([])
  }

  const onFaxNumberChange = (option) => {
    setSelectedPractice({
      ...selectedPractice,
      appId: option.appId,
      customerKey: option.customerKey,
      faxNumber: option.faxNumber,
      userId: option.userId,
    })
  }

  // useEffect(() => {
  //   setSearchText("")
  //   setSelectedDateRange(null)
  //   setDateRange([])
  // }, [selectedPractice])

  const containerFlex =
    tab === "setting"
      ? "0 0 85%"
      : selectedFax
        ? `0 0 ${faxListWidth}%`
        : "1 1 0"

  // const permittedTabs = tabs.filter((tab) => {
  //   return (
  //     authUser.userRole === "ADMIN" ||
  //     authUser.userRole === "SUPER_ADMIN" ||
  //     tab.key !== "setting"
  //   )
  // })

  // if (
  //   (!selectedPractice || Object.keys(selectedPractice).length === 0) &&
  //   tab !== "setting"
  // ) {
  //   return <></>
  // }

  const filteredTabs = tabs.filter((t) => {
    // Only ADMIN/SUPER_ADMIN can see Settings
    if (
      t.key === "setting" &&
      !["ADMIN", "SUPER_ADMIN", "USER"].includes(authUser.userRole)
    ) {
      return false
    }

    // Subfolder cannot see outbound
    if (selectedPractice?.type === "subfolder" && t.key === "outbound") {
      return false
    }

    if (practicesLength === 0 && t.key !== "setting") {
      return false
    }

    if (
      "USER" === authUser.userRole &&
      t.key !== "setting" &&
      tab === "setting"
    ) {
      return false
    }

    return true
  })

  // 🚫 Don't render if practice is not selected and not on "setting"
  if (
    (!selectedPractice || Object.keys(selectedPractice).length === 0) &&
    tab !== "setting" &&
    appLoading
  ) {
    return <></>
  }

  const inboundFaxNumbers =
    selectedPractice?.faxNumberAttributes?.map((a) => a.faxNumber).join(", ") ||
    []

  return (
    <div
      className="fax-list"
      style={{
        flex: `${containerFlex}`,
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <div style={{ flexShrink: 0 }}>
        {selectedPractice?.faxNumberAttributes?.length > 0 &&
          selectedPractice?.type !== "subfolder" && (
            <div
              style={{
                padding: "5px 5px 0px 5px",
                display: "flex",
                alignItems: "center",
                gap: "0px",
              }}
            >
              <span
                style={{
                  fontWeight: "bold",
                  backgroundColor: "#BC1B22",
                  padding: "10px",
                  color: "#FFF",
                  border: "1px solid #ccc",
                  whiteSpace: "nowrap",
                }}
              >
                {selectedPractice?.practiceName || ""}
              </span>
              <select
                id="appId"
                className="select-dropdown"
                style={{
                  width: "auto",
                  maxWidth: "100%",
                  marginLeft: "5px",
                  paddingRight: "40px",
                  minWidth: 0,
                }}
                onChange={(e) => {
                  const selected = selectedPractice?.faxNumberAttributes.find(
                    (a) => a.faxNumber === e.target.value,
                  )
                  onFaxNumberChange(selected)
                  setSearchText("")
                  setSelectedDateRange(null)
                  setDateRange([])
                  setTab("inbound")
                }}
                value={selectedPractice?.faxNumber || ""}
              >
                {selectedPractice?.faxNumberAttributes?.map((ass) => (
                  <option key={ass.faxNumber} value={ass.faxNumber}>
                    {ass.lastName
                      ? `${formatFaxNumber(ass.faxNumber)} (${ass.lastName})`
                      : formatFaxNumber(ass.faxNumber)}
                  </option>
                ))}
              </select>
            </div>
          )}

        <div
          className="list-header-container"
          style={{
            flexWrap: "wrap",
            alignItems: "center",
            gap: "5px",
            padding: "5px",
          }}
        >
          <div
            className="tabs-container"
            style={{ flex: "1 1 auto", margin: 0, minWidth: 0 }}
          >
            <div className="fax-view-tabs" style={{ width: "100%" }}>
              {filteredTabs?.map((t) => (
                <div
                  key={t.key}
                  className={`tab ${tab === t.key ? "selected" : ""}`}
                  onClick={() => handleTabClick(t.key)}
                >
                  {selectedPractice?.type === "subfolder" && t.key === "inbound"
                    ? "Copied"
                    : t.label}
                </div>
              ))}
            </div>
          </div>

          {(tab === "inbound" || tab === "outbound") && (
            <div
              className="search-container"
              style={{
                display: "flex",
                flexWrap: "nowrap",
                gap: "5px",
                alignItems: "center",
                flex: "0 0 auto",
                padding: 0,
                margin: 0,
              }}
            >
              {selectedPractice?.type !== "subfolder" && (
                <div className="search-input-wrapper">
                  <Flatpickr
                    value={selectedDateRange}
                    onChange={(selectedDates) => {
                      if (selectedDates.length === 2) {
                        const [startDate, endDate] = selectedDates
                        const diffDays = Math.floor(
                          (endDate - startDate) / (1000 * 60 * 60 * 24),
                        )
                        if (diffDays > 4) {
                          toast.error("Maximum allowed range is 5 days", {
                            duration: 5000,
                          })
                          setSelectedDateRange([startDate])
                          return
                        }
                        const start = new Date(
                          Date.UTC(
                            startDate.getFullYear(),
                            startDate.getMonth(),
                            startDate.getDate(),
                            0,
                            0,
                            0,
                          ),
                        )
                        const end = new Date(
                          Date.UTC(
                            endDate.getFullYear(),
                            endDate.getMonth(),
                            endDate.getDate(),
                            23,
                            59,
                            59,
                          ),
                        )
                        setDateRange([
                          start.toISOString().replace(/\.\d{3}Z$/, "Z"),
                          end.toISOString().replace(/\.\d{3}Z$/, "Z"),
                        ])
                        setSelectedDateRange([startDate, endDate])
                      }
                    }}
                    options={{
                      mode: "range",
                      dateFormat: "m/d/Y",
                      altInput: false,
                      maxDate: today,
                      minDate: past180Days,
                      defaultDate: [today],
                      position: "auto center",
                      appendTo: document.body,
                    }}
                    placeholder="Filter by date range"
                    className="flatpickr-input"
                    style={{ paddingRight: "24px", width: "210px" }}
                  />
                  {selectedDateRange?.length > 0 ? (
                    <button
                      type="button"
                      title="Clear"
                      onClick={() => {
                        setSelectedDateRange([])
                        setDateRange([])
                        setSearchText("")
                      }}
                      className="search-clear-btn"
                      style={{ right: 6, marginRight: "5px" }}
                    >
                      ✕
                    </button>
                  ) : null}
                </div>
              )}

              <div className="search-input-wrapper">
                <input
                  type="text"
                  placeholder={`${
                    tab === "printer"
                      ? "Printer "
                      : ["inbound", "outbound"].includes(tab)
                        ? "Fax "
                        : ""
                  }Search...`}
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  style={{ paddingRight: "22px" }}
                />
                <button
                  type="button"
                  onClick={() => setSearchText("")}
                  className="search-clear-btn"
                  style={{ visibility: searchText ? "visible" : "hidden" }}
                >
                  ✕
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      <div
        style={{
          flex: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        {(tab === "inbound" || tab === "outbound") && (
          <BoundInOut
            selectedPractice={selectedPractice}
            selectedFax={selectedFax}
            setSelectedFax={(fax) => setSelectedFax(fax)}
            tab={tab}
            searchText={searchText}
            flgReloadFaxes={flgReloadFaxes}
            reloadPractices={() => reloadPractices()}
            authUser={authUser}
            dateRange={dateRange}
            practices={practices}
          />
        )}
        {tab === "setting" && (
          <Setting authUser={authUser} practices={practices} />
        )}
      </div>
    </div>
  )
}

export default FaxList
